import { render, staticRenderFns } from "./NavBarItem.vue?vue&type=template&id=17e2d287&scoped=true"
import script from "./NavBarItem.vue?vue&type=script&lang=js"
export * from "./NavBarItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e2d287",
  null
  
)

export default component.exports